import React from "react";
import IconButton from "@material-ui/core/IconButton";
import FileCopyIcon from '@material-ui/icons/FileCopy';


export const CCopyIcon = (props) => {
    return(
        <IconButton style={{height:"30px", width:"30px"}} onClick={() => {navigator.clipboard.writeText(props.url)}}>< FileCopyIcon style={{color:"#1a1f36", height:"20px", width:"20px"}} /></IconButton>
    );
}